/**
 * Returns a style based on the students grade proximity, which is generated server side
 * @param status
 * @returns
 */
export const targetProximity = (status: string) => {
	switch (status) {
		case 'Above': {
			return { bg: 'THERMOMETER.tRed.4', color: 'UI.white' };
		}
		case 'Hit': {
			return { bg: 'THERMOMETER.tRed.4', color: 'UI.white' };
		}
		case 'HalfHit': {
			return { bg: 'THERMOMETER.tRed.1', color: 'THERMOMETER.tRed.0' };
		}
		case 'OneBelow': {
			return { bg: 'UI.secondary.4', color: 'UI.black' };
		}
		case 'WellBelow': {
			return { bg: 'THERMOMETER.tBlue.2', color: 'THERMOMETER.tBlue.8' };
		}
		default:
			return { bg: 'UI.secondary.4', color: 'UI.black' };
	}
};
